import * as React from 'react';

function SvgUnitedStates(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.73h35.54v-1.595H0v1.595z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 19.135h35.54v-1.594H0v1.594z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 17.542h35.54v-1.594H0v1.594z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15.948h35.54v-1.596H0v1.596z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14.352h35.54v-1.595H0v1.595z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12.758h35.54v-1.594H0v1.594z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.164h35.54V9.568H0v1.596z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.568h35.54V7.974H0v1.594z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.975h35.54V6.38H0v1.595z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.38h35.54V4.784H0V6.38z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.784h35.54V3.189H0v1.595z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.19h35.54V1.596H0V3.19z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.596h35.54V0H0v1.596z"
        fill="#CB001C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.164h16.23V0H0v11.164z"
        fill="#2A3560"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.328 1.654h-.44l.36.26-.142.422.36-.26.36.26-.136-.422.36-.26h-.445l-.139-.424-.138.424zM1.328 3.516h-.44l.36.26-.142.423.36-.26.36.26-.136-.424.36-.26h-.445l-.139-.42-.138.42zM1.328 5.379h-.44l.36.261-.142.422.36-.26.36.26-.136-.422.36-.261h-.445l-.139-.422-.138.422zM1.328 7.243h-.44l.36.261-.142.42.36-.259.36.26-.136-.42.36-.262h-.445l-.139-.423-.138.423zM1.328 9.108h-.44l.36.258-.142.423.36-.262.36.262-.136-.423.36-.258h-.445l-.139-.425-.138.425zM2.765 2.212l.132.422h.447l-.358.262.135.421-.356-.26-.358.26.134-.421-.357-.262h.444l.137-.422zM2.765 4.076l.132.42h.447l-.358.263.135.42-.356-.258-.358.258.134-.42-.357-.263h.444l.137-.42zM2.765 5.94l.132.42h.447l-.358.262.135.422-.356-.26-.358.26.134-.422-.357-.261h.444l.137-.422zM2.765 7.804l.132.42h.447l-.358.262.135.42-.356-.262-.358.262.134-.42-.357-.262h.444l.137-.42zM4.076 1.23l.139.423h.445l-.36.261.138.422-.362-.26-.356.26.137-.422-.36-.261h.443l.136-.423zM4.076 3.095l.139.42h.445l-.36.26.138.424-.362-.261-.356.261.137-.423-.36-.26h.443l.136-.421zM4.076 4.958l.139.42h.445l-.36.262.138.422-.362-.261-.356.261.137-.422-.36-.262h.443l.136-.42zM4.076 6.82l.139.423h.445l-.36.261.138.42-.362-.259-.356.26.137-.42-.36-.262h.443l.136-.423zM4.076 8.684l.139.423h.445l-.36.26.138.42-.362-.26-.356.261.137-.421-.36-.26h.443l.136-.423zM5.375 2.212l.136.422h.447l-.362.262.139.421-.36-.26-.358.26.139-.421-.363-.262h.445l.137-.422zM5.375 4.076l.136.42h.447l-.362.263.139.42-.36-.258-.358.258.139-.42-.363-.263h.445l.137-.42zM5.375 5.94l.136.42h.447l-.362.262.139.422-.36-.26-.358.26.139-.422-.363-.261h.445l.137-.422zM5.375 7.804l.136.42h.447l-.362.262.139.42-.36-.262-.358.262.139-.42-.363-.262h.445l.137-.42zM6.69 1.23l.139.423h.44l-.36.261.143.422-.362-.26-.36.26.137-.422-.356-.261h.442l.137-.423zM6.69 3.095l.139.42h.44l-.36.26.143.424-.362-.261-.36.261.137-.423-.356-.26h.442l.137-.421zM6.69 4.958l.139.42h.44l-.36.262.143.422-.362-.261-.36.261.137-.422-.356-.262h.442l.137-.42zM6.69 6.82l.139.423h.44l-.36.261.143.42-.362-.259-.36.26.137-.42-.356-.262h.442l.137-.423zM6.69 8.684l.139.423h.44l-.36.26.143.42-.362-.26-.36.261.137-.421-.356-.26h.442l.137-.423zM7.989 2.212l.137.422h.442l-.358.262.135.421-.356-.26-.358.26.135-.421-.358-.262h.442l.139-.422zM7.989 4.076l.137.42h.442l-.358.263.135.42-.356-.258-.358.258.135-.42-.358-.263h.442l.139-.42zM7.989 5.94l.137.42h.442l-.358.262.135.422-.356-.26-.358.26.135-.422-.358-.261h.442l.139-.422zM7.989 7.804l.137.42h.442l-.358.262.135.42-.356-.262-.358.262.135-.42-.358-.262h.442l.139-.42zM9.3 1.23l.139.423h.442l-.358.261.139.422-.362-.26-.356.26.135-.422-.358-.261h.442L9.3 1.23zM9.3 3.095l.139.42h.442l-.358.26.139.424-.362-.261-.356.261.135-.423-.358-.26h.442l.137-.421zM9.3 4.958l.139.42h.442l-.358.262.139.422-.362-.261-.356.261.135-.422-.358-.262h.442l.137-.42zM9.3 6.82l.139.423h.442l-.358.261.139.42-.362-.259-.356.26.135-.42-.358-.262h.442L9.3 6.82zM9.3 8.684l.139.423h.442l-.358.26.139.42-.362-.26-.356.261.135-.421-.358-.26h.442l.137-.423zM10.599 2.212l.136.422h.447l-.36.262.137.421-.36-.26-.358.26.139-.421-.36-.262h.444l.135-.422zM10.599 4.076l.136.42h.447l-.36.263.137.42-.36-.258-.358.258.139-.42-.36-.263h.444l.135-.42zM10.599 5.94l.136.42h.447l-.36.262.137.422-.36-.26-.358.26.139-.422-.36-.261h.444l.135-.422zM10.599 7.804l.136.42h.447l-.36.262.137.42-.36-.262-.358.262.139-.42-.36-.262h.444l.135-.42zM11.914 1.23l.138.423h.443l-.358.261.134.422-.357-.26-.356.26.134-.422-.357-.261h.442l.137-.423zM11.914 3.095l.138.42h.443l-.358.26.134.424-.357-.261-.356.261.134-.423-.357-.26h.442l.137-.421zM11.914 4.958l.138.42h.443l-.358.262.134.422-.357-.261-.356.261.134-.422-.357-.262h.442l.137-.42zM11.914 6.82l.138.423h.443l-.358.261.134.42-.357-.259-.356.26.134-.42-.357-.262h.442l.137-.423zM11.914 8.684l.138.423h.443l-.358.26.134.42-.357-.26-.356.261.134-.421-.357-.26h.442l.137-.423zM13.213 2.212l.134.422h.445l-.356.262.132.421-.355-.26-.363.26.14-.421-.357-.262h.44l.14-.422zM13.213 4.076l.134.42h.445l-.356.263.132.42-.355-.258-.363.258.14-.42-.357-.263h.44l.14-.42zM13.213 5.94l.134.42h.445l-.356.262.132.422-.355-.26-.363.26.14-.422-.357-.261h.44l.14-.422zM13.213 7.804l.134.42h.445l-.356.262.132.42-.355-.262-.363.262.14-.42-.357-.262h.44l.14-.42zM14.524 1.23l.14.423h.44l-.357.261.139.422-.362-.26-.356.26.134-.422-.358-.261h.443l.136-.423zM14.524 3.095l.14.42h.44l-.357.26.139.424-.362-.261-.356.261.134-.423-.358-.26h.443l.136-.421zM14.524 4.958l.14.42h.44l-.357.262.139.422-.362-.261-.356.261.134-.422-.358-.262h.443l.136-.42zM14.524 6.82l.14.423h.44l-.357.261.139.42-.362-.259-.356.26.134-.42-.358-.262h.443l.136-.423zM14.524 8.684l.14.423h.44l-.357.26.139.42-.362-.26-.356.261.134-.421-.358-.26h.443l.136-.423z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgUnitedStates;
